'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _irisPropTypes = require('@spp/iris-prop-types');

var _ImageAsset = require('./ImageAsset');

var _ImageAsset2 = _interopRequireDefault(_ImageAsset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image = function (_Component) {
    (0, _inherits3.default)(Image, _Component);

    function Image() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Image);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Image.__proto__ || (0, _getPrototypeOf2.default)(Image)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            expanedCaption: false,
            isCaptionOverFlown: false
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }
    // https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/article/components.md#image


    (0, _createClass3.default)(Image, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var isOverflown = Image.isOverflown(this.caption);
            this.setState({ // eslint-disable-line react/no-did-mount-set-state
                isCaptionOverFlown: isOverflown
            });
        }
    }, {
        key: 'toggleCaption',
        value: function toggleCaption() {
            this.setState({ expanedCaption: !this.state.expanedCaption });
        }
    }, {
        key: 'renderCaption',
        value: function renderCaption() {
            var captionValue = this.props.caption.value;


            if (!captionValue) {
                return null;
            }

            return _react2.default.createElement(
                'span',
                { className: this.props.theme['caption-text'], 'data-test-tag': '@spp/ui-image:caption' },
                captionValue
            );
        }
    }, {
        key: 'renderByline',
        value: function renderByline() {
            var bylineValue = this.props.byline.title;


            if (!bylineValue) {
                return null;
            }

            return _react2.default.createElement(
                'span',
                { className: this.props.theme['byline-text'], 'data-test-tag': '@spp/ui-image:byline' },
                bylineValue
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var captionClass = this.props.showFullCaption || this.state.expanedCaption ? this.props.theme.fullcaption : this.props.theme.caption;

            var renderButton = this.state.isCaptionOverFlown;

            return _react2.default.createElement(
                'figure',
                {
                    className: this.props.theme.root,
                    'data-test-tag': '@spp/ui-image'
                },
                _react2.default.createElement(_ImageAsset2.default, (0, _extends3.default)({
                    theme: this.props.theme.image, altText: this.props.altText
                }, this.props.imageAsset, { sizes: this.props.sizes, testTag: '@spp/ui-image:image-asset'
                })),
                _react2.default.createElement(
                    'figcaption',
                    {
                        className: captionClass, ref: function ref(c) {
                            _this2.caption = c;
                        }
                    },
                    this.renderCaption(),
                    ' ',
                    this.renderByline()
                ),
                renderButton && _react2.default.createElement(
                    'button',
                    {
                        'aria-hidden': 'true', className: this.props.theme.captionButton,
                        'data-test-tag': '@spp/ui-image:button',
                        onClick: function onClick() {
                            return _this2.toggleCaption();
                        }
                    },
                    this.state.expanedCaption ? this.props.labels.close : this.props.labels.readMore
                )
            );
        }
    }], [{
        key: 'isOverflown',
        value: function isOverflown(element) {
            return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
        }
    }]);
    return Image;
}(_react.Component);

Image.propTypes = {
    altText: _propTypes2.default.string,
    theme: _propTypes2.default.shape({
        'byline-text': _propTypes2.default.string,
        'caption-text': _propTypes2.default.string,
        caption: _propTypes2.default.string,
        root: _propTypes2.default.string,
        image: _propTypes2.default.string,
        fullcaption: _propTypes2.default.string,
        captionButton: _propTypes2.default.string
    }),
    byline: _irisPropTypes.objects.originator,
    caption: _irisPropTypes.objects.caption,
    labels: _propTypes2.default.shape({
        readMore: _propTypes2.default.string,
        close: _propTypes2.default.string
    }),
    imageAsset: _propTypes2.default.shape(_ImageAsset2.default.propTypes).isRequired,
    showFullCaption: _propTypes2.default.bool,
    sizes: _propTypes2.default.string
};
Image.defaultProps = {
    altText: '',
    theme: {},
    byline: {
        title: ''
    },
    caption: {
        value: ''
    },
    labels: {
        readMore: 'Read more',
        close: 'Close'
    },
    showFullCaption: true,
    sizes: undefined
};
exports.default = Image;
//# sourceMappingURL=Image.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-image/lib/cjs/Image.js
 ** module id = 660
 ** module chunks = 1
 **/